import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from 'axios'
import moment from 'moment'
import vuetify from './plugins/vuetify';
import VCalendar from 'v-calendar'
import VueTagManager from "vue-tag-manager"
import VueEulerian from 'vue-eulerian'
import sha256 from 'sha256';
import Utils from '@/Utils.js';
import Rules from '@/Rules.js';
import ConstOneTrust from '@/oneTrustConst.js';

Vue.config.productionTip = false;

//Modifier le préfixe pour v-calendar
Vue.use(VCalendar, {
    componentPrefix: 'vc'
});

moment.locale('fr');
Vue.prototype.$moment = moment
Vue.prototype.$sha256 = sha256
Vue.prototype.$utils = Utils

// Liste des rules de validation pour tout le site
Vue.prototype.$rules = Rules

// Créer l'objet axios à utiliser dans l'pplication
var axios = Axios.create({

    // Définir l'adresse de base des services pour axios
    baseURL: `${process.env.VUE_APP_BASE_API_URL}`
});
Vue.prototype.$http = axios

// Instanciation des tag analytics google
if (Utils.getIdTagGoogleParEcole()) {
    Vue.use(VueTagManager, {
        gtmId: Utils.getIdTagGoogleParEcole()
    })
}

// Instanciation des tag analytics eulerian
if (Utils.getIdTagEulerianParEcole()) {
    Vue.use(VueEulerian, { id: Utils.getIdTagEulerianParEcole() })
}

// Constante indiquant le nombre de minute avant le timeout.
const timeOutCandidature = 120

Vue.prototype.$storeCandidature = {

    // Constantes
    constantes: {
        // Format PJ non supporté
        formatPjNonSupporte: "heic",

        // Mot clé envoyé dans l'id crypté retournée par le service de création en cas de candidature en double
        motCleDoublon: "doublon",

        // Chemin router pour le dashboard
        pathDashboard: "/dashboard",
    },

    // Flags
    loadingConfig: false,
    loadingCandidature: false,
    candidatureEnDouble: false,

    // Taille des fichiers récemment ajouté dans pj
    tailleUpload: 0,

    // Flag de validité de paiement
    paiementRealise: false,

    // Flag de redirection concours
    redirectionConcours: {
        AfficherDialog: false,
        NomProgramme: null,
        RedirectUrl: null,
        LogoUrl: null
    },

    // Langue du formulaire
    langueFormulaire: "fr",

    // Source contact reçu dans l'url 'param utm_source'
    utmSourceParam: null,

    // Source contact reçu dans l'url 'param utm_medium'
    utmMediumParam: null,

    // Source contact reçu dans l'url 'param fbclid'
    fbclidParam: null,

    // Source contact reçu dans l'url 'param gclid'
    gclidParam: null,

    // Source contact reçu dans l'url 'param eulerian'
    eulerianParam: null,

    // Flag de modufication des étapes
    candidatureChanged: false,

    // Dialog timeout
    dialogTimeOut: false,

    // Variable contenant l'heure et date du chargement de la page.
    dateChargementPage: moment().format("DD/MM/YYYY HH:mm:ss"),

    // Configuration cilent
    configurationClient: {
        Loaded: false,
        ParamFormulaire: {
            ListeSessionsConcoursAAffciher: [],
            TypesEtudes: [],
            SpecialitesEtudes: [],
            Specialites: []
        },

        // Liste des catalogues récupérés
        CiviliteList: [],
        Sexelist: [],
        PaysList: [],
        EcoleList: [],
        NiveauEtudesParcoursList: [],
        LangueEtudeList: [],
        StatutBacList: [],
        SerieList: [],
        MentionList: [],
        AnneeObtentionList: [],
        SituationActuelleList: [],
        OptionList: [],
        AcademieList: [],
        SourceDeclarativeList: [],
        AnneeScolaireList: [],
        LangueList: [],
        TypeLangueList: [],
        SituationFinanciereList: [],
        StatutVae: [],
        SituationActuelleIdentificationList: [],
        ModeDeFinancementList: [],
        CandidatureCycleList: [],
        TypeContratList: [],
        AnneesExperienceProList: [],
    },

    // Id de l'école du formulaire
    dataIdEcoleFormulaire: {},

    // Id du Formulaire Candidature : sert pour le filtrage des programme pour Esce, Bachemors et Ebs
    dataIdFormulaireCandidature: {},

    // Sas de la candidature
    sasCandidature: {
        Ecole: {},
        Identification: {
            TypeEtudes: null,
            SpecialiteEtudes: null,
            DateNissanceSaisie: null
        },
        ChoixProgramme: {
            NomProgramme: null,
            SessionFormulaire: null,
            M2EnvisageFormulaire: null,
            M2Envisage2: null,
            M2Envisage3: null
        },
        InformationsComplementaires: {},
        ParcoursScolaireTerminale: {
            EtablissementTerminale: null,
            EtablissementPostBac: null
        },
        ParcoursScolaireSuperieur: {
            EtablissementTerminale: null,
            EtablissementPostBac: null
        },
        VAECoursDuSoir: {},
        SituationActuelle: {},
        LoisirsVieAssociative: {},
        StagesExperiencesPro: {},
        SessionChoisie: {},
        ListeFreresSoeurs: [],
        ListeLangues: [],
        ListeSejoursEtranger: [],
        ListeParcoursScolaire: [],
        ListePiecesJustificatives: [],
        ListSituationActuelle: [],

        // Alimenter la valeur de la langue du formulaire
        LangueFormulaire: null,

        // SourceContactFormulaire
        UtmSourceParamUrl: null,
        UtmMediumParamUrl: null,
        GclidParamUrl: null,
        FbclidParamUrl: null,
        EulerianParamUrl: null,
    },

    // Dto de paiement Mercanet
    paiemenyDto: {},

    // Listes Tab déroulantes
    filtreProgrammeListes: {
        ProgrammesList: [],
        RentreesProgrammesList: [],
        LangueEtudeList: [],
        NiveauxAdmissionList: [],
        EcolesProposees: [],
        CampusList: []
    },

    sessionList: [],
    etablissementFrequenteList: [],
    etablissementFrequenteTerminaleList: [],
    etablissementFrequentePostBacList: [],    
    etablissementInseecList: [],

    // Flags de validation des étpaes    
    etapeIentificationValide: true,
    etapeCoixProgrammeValide: true,
    etapeInfoSpplementairesValide: true,
    etapeInfoSpplementaires2Valide: true,
    etapePaiementValide: true,
    etapeValidationValide: true,

    // Flag de validation des zones dans l'étape 6 (Validation)
    ValidationIdentificationOK: true,
    ValidationChoixProgrammeOK: true,
    ValidationInformationSupplementaireOK: true,
    ValidationInformationSupplementaire2OK: true,
    ValidationPiecesJointesOK: true,
    ValidationPaiementOK: true,

    // Initiliser la candidature
    initCandidature() {
        this.sasCandidature = {
            Ecole: { Lang00: '', Id: this.dataIdEcoleFormulaire },
            Identification: {
                TypeEtudes: null,
                SpecialiteEtudes: null,
                DateNissanceSaisie: null
            },
            ChoixProgramme: {
                NomProgramme: null,
                SessionFormulaire: null,
                M2EnvisageFormulaire: null,
                M2Envisage2: null,
                M2Envisage3: null
            },
            InformationsComplementaires: {},
            ParcoursScolaireTerminale: {
                EtablissementTerminale: null,
                EtablissementPostBac: null
            },
            ParcoursScolaireSuperieur: {
                EtablissementTerminale: null,
                EtablissementPostBac: null
            },
            VAECoursDuSoir: {},
            SituationActuelle: {},
            LoisirsVieAssociative: {},
            StagesExperiencesPro: {},
            SessionChoisie: {},
            ListeFreresSoeurs: [],
            ListeLangues: [],
            ListeSejoursEtranger: [],
            ListeParcoursScolaire: [],
            ListePiecesJustificatives: [],

            // Alimenter la langue du formulaire
            LangueFormulaire: this.langueFormulaire,

            // SourceContactFormulaire
            UtmSourceParamUrl: this.utmSourceParam,
            UtmMediumParamUrl: this.utmMediumParam,
            GclidParamUrl: this.gclidParam,
            FbclidParamUrl: this.fbclidParam,
            EulerianParamUrl: this.eulerianParam,
        }
    },

    // Affecter ou initialiser le sasCandidature
    affecterSasCandidature(data) {
        this.sasCandidature = data;

        // Transformer le sas null en objet vide pour ne pas planter les mapping 'v-model'
        if (!this.sasCandidature) {
            this.initCandidature();
        } else {
            // Alimenter la langue du formulaire
            this.sasCandidature.LangueFormulaire = this.langueFormulaire

            if (!this.sasCandidature.Identification) {
                this.sasCandidature.Identification = {
                    TypeEtudes: null,
                    SpecialiteEtudes: null,
                    DateNissanceSaisie: null
                };
            } else {
                // Convertir la date
                if (this.sasCandidature.Identification.DateNaissance) {
                    this.sasCandidature.Identification.DateNissanceSaisie = moment(String(this.sasCandidature.Identification.DateNaissance)).format('DD/MM/YYYY')
                    this.sasCandidature.Identification.DateNaissance = new Date(this.sasCandidature.Identification.DateNaissance)
                }
                else {
                    this.sasCandidature.Identification.DateNaissance = ''
                }
            }

            if (!this.sasCandidature.ChoixProgramme) {
                this.sasCandidature.ChoixProgramme = {
                    NomProgramme: null,
                    Session: null
                };
            }
            if (!this.sasCandidature.InformationsComplementaires) {
                this.sasCandidature.InformationsComplementaires = {};
            }
            if (!this.sasCandidature.ParcoursScolaireTerminale) {
                this.sasCandidature.ParcoursScolaireTerminale = {
                    EtablissementTerminale: null
                };
            }
            if (!this.sasCandidature.ParcoursScolaireSuperieur) {
                this.sasCandidature.ParcoursScolaireSuperieur = {
                    EtablissementTerminale: null
                };
            }
            if (!this.sasCandidature.LoisirsVieAssociative) {
                this.sasCandidature.LoisirsVieAssociative = {};
            }
            if (!this.sasCandidature.StagesExperiencesPro) {
                this.sasCandidature.StagesExperiencesPro = {};
            }
            if (!this.sasCandidature.VAECoursDuSoir) {
                this.sasCandidature.VAECoursDuSoir = {};
            }
            if (!this.sasCandidature.SituationActuelle) {
                this.sasCandidature.SituationActuelle = {};
            }
        }
    },

    // Charger la configuration client
    ChargerConfiguration(ecoleId, dataIdEcoleFormulaire, reloadCache) {
        if (this.configurationClient != null && this.configurationClient != {}) {
            return axios.post('ChargerConfigurationClientExtranet', null, { params: { ecoleId: ecoleId, formulaireCandidatureId: dataIdEcoleFormulaire, langueFormulaire: this.langueFormulaire, reloadCache: reloadCache } })
        }
    },

    // Afficher l'annexe
    afficherAnnexe(urlFile) {
        window.open(urlFile, '_blank');
    },

    //Repositionner la france en tête de la liste des pays
    paysFranceTeteDeListe() {
        var filedataFrance = this.configurationClient.PaysList.filter(pays => pays.Id == this.configurationClient.DataIdFrance);
        this.configurationClient.PaysList = this.configurationClient.PaysList.filter(pays => pays.Id != this.configurationClient.DataIdFrance);
        this.configurationClient.PaysList = filedataFrance.concat(this.configurationClient.PaysList);
    },

    async chargerListesEtablissementFrequenteTerminal(labelEtablissement) {

        // Ne pas faire la recherche si pas de label saisie.
        if (labelEtablissement.length > 0) {

            // Charger établissement fréquenté
            await axios.post("EtablissementFrequente", null, { params: { labelEtablissement: labelEtablissement } })
                .then(response => {

                    // Succés
                    if (response.data) {
                        this.etablissementFrequenteTerminaleList = response.data
                    }
                })
        }
    },

    async chargerListesEtablissementFrequentePostBacList(labelEtablissement) {

        // Ne pas faire la recherche si pas de label saisie.
        if (labelEtablissement.length > 0) {

            // Charger établissement fréquenté
            await axios.post("EtablissementFrequente", null, { params: { labelEtablissement: labelEtablissement } })
                .then(response => {

                    // Succés
                    if (response.data) {
                        this.etablissementFrequentePostBacList = response.data
                    }
                })
        }
    },

    // Recherche des etablissment frequenté.
    async chargerListesEtablissementFrequente(labelEtablissement) {

        // Ne pas faire la recherche si pas de label saisie.
        if (labelEtablissement.length > 0) {

            // Charger établissement fréquenté
            await axios.post("EtablissementFrequente", null, { params: { labelEtablissement: labelEtablissement } })
                .then(response => {

                    // Succés
                    if (response.data) {
                        this.etablissementFrequenteList = response.data
                    }
                })
        }
    },

    // Charger les listes déroulantes
    chargerListesDeroulantes(stopLoading) {

        // Charger établissement du groupe INSEEC
        axios.post("EtablissementFrequente", null, { params: { groupINSEEC: true } }
        ).then(response => {
            // Succés
            if (response.data) {
                this.etablissementInseecList = response.data
                if (stopLoading) {
                    // Arréter le flag de chargement
                    this.loadingConfig = false
                    // this.updateCentreonStatut()      // Plus besoin de mettre à jour la balise, le client demande de la mettre en dure
                }
            }
            else {
                if (stopLoading) {
                    // Arréter le flag de chargement
                    this.loadingConfig = false
                    // this.updateCentreonStatut()      // Plus besoin de mettre à jour la balise, le client demande de la mettre en dure
                }
            }
        })
    },

    // Fonction pour récupérer les lsite déroulantes (FileData)
    chargerFileData(descId, ecoleId, formulaireId, parentDataIds, sansDoublon, triParCode) {
        var url = "FileData?";
        if (descId) {
            url += "descId=" + descId;
        }
        if (ecoleId) {
            url += "&ecoleId=" + ecoleId;
        }
        if (formulaireId) {
            url += "&formulaireCandidatureId=" + formulaireId;
        }
        if (parentDataIds) {
            url += "&parentDataIds=" + parentDataIds;
        }
        if (sansDoublon) {
            url += "&sansDoublon=" + "1";
        }
        if (triParCode) {
            url += "&triParCode=" + "1";
        }
        return axios.post(url);
    },

    // Charger Programme
    chargerProgrammes(ecoleId, initValeur, modeMaster) {
        // Si nous somme dans le formulaire masterinseec on va dans la focntion de chargement des sessions 
        if (ecoleId == this.configurationClient.DataIdEcoleInseecMscMba || modeMaster) {
            this.chargerSessionsProg(ecoleId, initValeur);
            return
        }

        // Si on est dans un évènement de OnChange on initilisa la valuer du programme de la candidature
        if (initValeur) {
            this.sasCandidature.ChoixProgramme.NomProgramme = null
        }

        var url = "Programmes";

        axios.post(url, null, {
            params: {
                ecoleId: ecoleId,
                formulaireCandidatureId: this.dataIdFormulaireCandidature ? this.dataIdFormulaireCandidature : null,
                niveauAdmissionId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.NiveauAdmission ?
                    this.sasCandidature.ChoixProgramme.NiveauAdmission.Id : null,
                campusId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.Campus ?
                    this.sasCandidature.ChoixProgramme.Campus.Id : null,
                langueId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.LangueEtude ?
                    this.sasCandidature.ChoixProgramme.LangueEtude.Id : null,
                rentreeId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.Rentree ?
                    this.sasCandidature.ChoixProgramme.Rentree.Id : null,
                niveauEtudesId: this.sasCandidature
                    && this.sasCandidature.Identification
                    && this.sasCandidature.Identification.NiveauEtudes ?
                    this.sasCandidature.Identification.NiveauEtudes.Id : null,
                typeEtudesId: this.sasCandidature
                    && this.sasCandidature.Identification
                    && this.sasCandidature.Identification.TypeEtudes ?
                    this.sasCandidature.Identification.TypeEtudes.Id : null,
                speciliteEtudesId: this.sasCandidature
                    && this.sasCandidature.Identification
                    && this.sasCandidature.Identification.SpecialiteEtudes ?
                    this.sasCandidature.Identification.SpecialiteEtudes.Id : null,
                poleDisciplinaireId: this.sasCandidature
                    && this.sasCandidature.PoleDisciplinaire ?
                    this.sasCandidature.PoleDisciplinaire.Id : null,
                ecoleChoisieId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.EcoleChoisie ?
                    this.sasCandidature.ChoixProgramme.EcoleChoisie.Id : null,
            }
        }).then(response => {
            // Succés
            if (response.data) {
                this.filtreProgrammeListes = response.data

                // Selectionner la valeur par défaut si la liste ne contine qu'un seul élément
                if (this.filtreProgrammeListes && this.filtreProgrammeListes.ProgrammesList) {
                    if (this.filtreProgrammeListes.ProgrammesList.length == 1
                        && !this.sasCandidature.ChoixProgramme.NomProgramme) {
                        this.sasCandidature.ChoixProgramme.NomProgramme = this.filtreProgrammeListes.ProgrammesList[0]
                    }
                }
                else {
                    //Si la liste des prgrammes est vide et les données de filtrage ne le sont pas,
                    // on initialiser les données du filtre pour permettre la visibilité des champs sélectionné
                    if (!this.filtreProgrammeListes.ProgrammesList) {
                        if (this.sasCandidature.ChoixProgramme.Rentree) {
                            this.filtreProgrammeListes.RentreesProgrammesList = [this.sasCandidature.ChoixProgramme.Rentree]
                        }
                        if (this.sasCandidature.ChoixProgramme.NiveauAdmission) {
                            this.filtreProgrammeListes.NiveauxAdmissionList = [this.sasCandidature.ChoixProgramme.NiveauAdmission]
                        }
                        if (this.sasCandidature.ChoixProgramme.LangueEtude) {
                            this.filtreProgrammeListes.LangueEtudeList = [this.sasCandidature.ChoixProgramme.LangueEtude]
                        }
                        if (this.sasCandidature.ChoixProgramme.EcoleChoisie) {
                            this.filtreProgrammeListes.EcolesProposees = [this.sasCandidature.ChoixProgramme.EcoleChoisie]
                        }
                        if (this.sasCandidature.ChoixProgramme.Campus) {
                            this.filtreProgrammeListes.CampusList = [this.sasCandidature.ChoixProgramme.Campus]
                        }

                        this.sasCandidature.ChoixProgramme.NomProgramme = null
                    }
                }
                // Arréter le flag de chargement
                this.loadingConfig = false
            }
        })
    },

    // Charger Sessions des programmes
    chargerSessionsProg(ecoleId, initValeur) {

        // Si on est dans un évènement de OnChange on initilisa des valeurs saisis
        if (initValeur) {
            this.sasCandidature.ChoixProgramme.M2EnvisageFormulaire = null
            this.sasCandidature.ChoixProgramme.M2Envisage2 = null
            this.sasCandidature.ChoixProgramme.M2Envisage3 = null
            this.sasCandidature.ChoixProgramme.SessionFormulaire = null
        }

        var url = "Sessions";

        axios.post(url, null, {
            params: {
                ecoleId: ecoleId,
                formulaireCandidatureId: this.dataIdFormulaireCandidature ? this.dataIdFormulaireCandidature : null,
                niveauAdmissionId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.NiveauAdmission ?
                    this.sasCandidature.ChoixProgramme.NiveauAdmission.Id : null,
                campusId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.Campus ?
                    this.sasCandidature.ChoixProgramme.Campus.Id : null,
                rentreeId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.Rentree ?
                    this.sasCandidature.ChoixProgramme.Rentree.Id : null,
            }
        }).then(response => {
            // Succés
            if (response.data) {
                this.filtreProgrammeListes = response.data

                // Selectionner la valeur par défaut si la liste ne contine qu'un seul élément
                if (this.filtreProgrammeListes && this.filtreProgrammeListes.SessionsList) {
                    // Si le niveau d'addmission saisi est 1ère ou 4ème année (4209 / 1003779)
                    if (this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.NiveauAdmission
                        && (this.sasCandidature.ChoixProgramme.NiveauAdmission == this.configurationClient.DataIdNiveauAdmissionMsc1erAnnee
                            || this.sasCandidature.ChoixProgramme.NiveauAdmission == this.configurationClient.Niveau4emeAnnee)) {
                        if (this.filtreProgrammeListes.SessionsList.length == 1
                            && !this.sasCandidature.ChoixProgramme.Session) {
                            this.sasCandidature.ChoixProgramme.Session = this.filtreProgrammeListes.SessionsList[0]
                        }
                    }
                    else {
                        if (this.filtreProgrammeListes.SessionsList.length == 1
                            && !this.sasCandidature.ChoixProgramme.Session) {
                            this.sasCandidature.ChoixProgramme.Session = this.filtreProgrammeListes.SessionsList[0]
                        }
                    }
                }
                else {
                    //Si la liste des prgrammes est vide et les données de filtrage ne le sont pas,
                    // on initialiser les données du filtre pour permettre la visibilité des champs sélectionné
                    if (!this.filtreProgrammeListes.SessionsList) {
                        if (this.sasCandidature.ChoixProgramme.Rentree) {
                            this.filtreProgrammeListes.RentreesProgrammesList = [this.sasCandidature.ChoixProgramme.Rentree]
                        }
                        if (this.sasCandidature.ChoixProgramme.NiveauAdmission) {
                            this.filtreProgrammeListes.NiveauxAdmissionList = [this.sasCandidature.ChoixProgramme.NiveauAdmission]
                        }
                        if (this.sasCandidature.ChoixProgramme.Campus) {
                            this.filtreProgrammeListes.CampusList = [this.sasCandidature.ChoixProgramme.Campus]
                        }

                        this.$storeCandidature.sasCandidature.ChoixProgramme.M2EnvisageFormulaire = null
                        this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage2 = null
                        this.$storeCandidature.sasCandidature.ChoixProgramme.M2Envisage3 = null
                        this.$storeCandidature.sasCandidature.ChoixProgramme.SessionFormulaire = null
                    }
                }
                // Arréter le flag de chargement
                this.loadingConfig = false
            }
        })
    },

    // Cocher la sessions coucours si on a une déjà sur la candidature
    cocherSessionChoisie() {
        if (this.sasCandidature.SessionChoisie && this.sasCandidature.SessionChoisie.Id &&
            this.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher &&
            this.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher.length > 0) {

            for (var i = 0; i < this.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher.length; i++) {
                if (this.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher[i].Id == this.sasCandidature.SessionChoisie.Id) {
                    this.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher[i].ChoixOk = true
                }
            }
        }
    },

    // Fonction de chargement de l'objet de paiement Mercanet
    chargerObjetDePaiement(candidatureId, key) {
        // appeler le web service orm pour le paiement
        return axios.post("InitMercanet?CdtId=" + candidatureId + "&Key=" + key);
    },

    // Fonction de mise à jour des informations de paiement sur la candidature paiement Mercanet 
    majInfosPaiement(candidatureId, key, newRef) {
        // appeler le web service orm pour le paiement
        return axios.post("MajRefPaiement?CdtId=" + candidatureId + "&Key=" + key + "&newRef=" + newRef);
    },

    // Vérifier la validation des pièce jointe
    ValiderListesPiecesJointes() {
        // Vérifier s'il manques des pièces non ajoutées
        if (!this.configurationClient.ParamFormulaire.AjoutPJNonObligatoire && this.sasCandidature.ListePiecesJustificatives) {
            for (var i = 0; i < this.sasCandidature.ListePiecesJustificatives.length; i++) {

                if ((this.sasCandidature.ListePiecesJustificatives[i].Type && this.sasCandidature.ListePiecesJustificatives[i].Type.Code != "F") &&
                    !this.sasCandidature.ListePiecesJustificatives[i].NomPieceJointe) {
                    this.ValidationPiecesJointesOK = false;
                    return false
                }
            }
        }

        // Vérifier si toutes les pièces sont Validées
        if (!this.configurationClient.ParamFormulaire.ValidationPJNonObligatoire && this.sasCandidature.ListePiecesJustificatives) {
            for (var j = 0; j < this.sasCandidature.ListePiecesJustificatives.length; j++) {
                if ((this.sasCandidature.ListePiecesJustificatives[j].Type && this.sasCandidature.ListePiecesJustificatives[j].Type.Code != "F") &&
                    !this.sasCandidature.ListePiecesJustificatives[j].Valide) {
                    this.ValidationPiecesJointesOK = false;
                    return false
                }
            }
        }
        this.ValidationPiecesJointesOK = true
        return true
    },

    // Vérifier la validation du paiement
    ValiderPaiement() {
        // Si le montant est 0 ou le paiement est fait par cheque, virement on renvoie vraie       
        if ((this.sasCandidature.Montant == 0) || this.sasCandidature.ModePaiement && this.configurationClient.ModePaiementChequeId && this.configurationClient.ModePaiementVirementId
            && (this.sasCandidature.ModePaiement.Id == this.configurationClient.ModePaiementChequeId
                || this.sasCandidature.ModePaiement.Id == this.configurationClient.ModePaiementVirementId)) {
            this.ValidationPaiementOK = true;
            return true;
        }
        else {
            // Si le paiement est fait par CB ou Code promo,on vérifie si la candidature est payée
            if (this.sasCandidature.ModePaiement && this.configurationClient.ModePaiementCbId && this.configurationClient.ModePaiementCodePromoId
                && (this.sasCandidature.ModePaiement.Id == this.configurationClient.ModePaiementCbId
                    || this.sasCandidature.ModePaiement.Id == this.configurationClient.ModePaiementCodePromoId)
                && this.sasCandidature.PaiementRealise) {
                this.ValidationPaiementOK = true;
                return true;
            }
        }

        this.ValidationPaiementOK = false
        return false
    },

    // Vérifier la validation du code promo
    verifierValiditeCodePromo() {

        // Appeler le webservice de vérification des doublon
        return axios.post('VerifierCodePromo', null, {
            params: {
                code: this.sasCandidature
                    && this.sasCandidature.CodePromoEtudiant ? this.sasCandidature.CodePromoEtudiant : null,
                ecoleId: this.sasCandidature && this.dataIdEcoleFormulaire ? this.dataIdEcoleFormulaire : null,
                formulaireCandidatureId: this.dataIdFormulaireCandidature ? this.dataIdFormulaireCandidature : null
            }
        });
    },

    // Récupérer la première valeur du param
    getFirstValueParamUrl(valueParam) {
        if (valueParam) {
            return valueParam.split('|')[0]
        }
    },

    // Récupérer les params SourceDetaille de l'url
    getSourceDetailleePrams(urlQuery) {
        // Pour Google
        this.utmSourceParam = this.getFirstValueParamUrl(urlQuery.utm_source)
        this.utmMediumParam = this.getFirstValueParamUrl(urlQuery.utm_medium)
        this.gclidParam = this.getFirstValueParamUrl(urlQuery.gclid)

        // Pour facebook
        this.fbclidParam = this.getFirstValueParamUrl(urlQuery.fbclid)

        // Pour Eulerian
        this.eulerianParam = this.getFirstValueParamUrl(urlQuery["ead-publisher"])

        if (this.eulerianParam == null) {
            this.eulerianParam = this.getFirstValueParamUrl(urlQuery["esc-publisher"])
        }

        if (this.eulerianParam == null) {
            this.eulerianParam = this.getFirstValueParamUrl(urlQuery["esl-k"])
        }

        if (this.eulerianParam == null) {
            this.eulerianParam = this.getFirstValueParamUrl(urlQuery["eml-publisher"])
        }

        if (this.eulerianParam == null) {
            this.eulerianParam = this.getFirstValueParamUrl(urlQuery["etf-publisher"])
        }

        console.log('utmSourceParam : ' + this.utmSourceParam)
        console.log('utmMediumParam : ' + this.utmMediumParam)
        console.log('gclidParam : ' + this.gclidParam)
        console.log('fbclidParam : ' + this.fbclidParam)
        console.log('eulerianParam : ' + this.eulerianParam)
    },

    // Verifier si le numéro de téléphone est vide ou n'est valide
    numeroTelephoneVide() {
        // Mettre le message d'erreur de validation
        this.messageErreurValidation = "Provide a valid phone number";

        // Renvoyé sur la bonne étape manquante
        if (!this.sasCandidature.Identification.Telephone) {
            this.showErrorValidation = true
            return true
        } else {
            this.showErrorValidation = false
            return false
        }
    },
    // Vérifier si la candidature doit être redirigé vers un concours
    verifierRedirectionConcours() {
        // Initilaiser la valeur d'affichage du dialog
        this.redirectionConcours.AfficherDialog = false

        return axios.post("VerifRedirectionConcours", null, {
            params: {
                CdtId: this.sasCandidature
                    && this.sasCandidature.IdCrypte ? this.sasCandidature.IdCrypte : null,
                Key: this.sasCandidature
                    && this.sasCandidature.KeyCrypte ? this.sasCandidature.KeyCrypte : null,
                ecoleId: this.dataIdEcoleEce,
                programmeId: this.sasCandidature
                    && this.sasCandidature.ChoixProgramme
                    && this.sasCandidature.ChoixProgramme.NomProgramme ?
                    this.sasCandidature.ChoixProgramme.NomProgramme.Id : null,
                niveauEtudesId: this.sasCandidature
                    && this.sasCandidature.Identification
                    && this.sasCandidature.Identification.NiveauEtudes ?
                    this.sasCandidature.Identification.NiveauEtudes.Id : null,
                typeEtudesId: this.sasCandidature
                    && this.sasCandidature.Identification
                    && this.sasCandidature.Identification.TypeEtudes ?
                    this.sasCandidature.Identification.TypeEtudes.Id : null,
                speciliteEtudesId: this.sasCandidature
                    && this.sasCandidature.Identification
                    && this.sasCandidature.Identification.SpecialiteEtudes ?
                    this.sasCandidature.Identification.SpecialiteEtudes.Id : null
            }
        })
    },

    messageCandidatureDoublon() {
        if (this.langueFormulaire == 'en')
            return "You already have an application in progress. Please click on the link sent to you by email to get it, .\nPlease contact the admissions department if you stil have the problem."
        else
            return "Vous avez déjà une candidature en cours. Afin de la récupérer, merci de cliquer sur le lien qui vous a été envoyé par mail.\nEn cas de problème, veuillez vous rapprocher du service des admissions."
    },

    // Récupérer la liste des valeur d'un catalogue multiple
    getListeValeuresCatlogueMultiple(listeCatalogue, langue) {
        if (!listeCatalogue) { return null; }

        var listeValeurs = '';
        listeCatalogue.forEach(function (element) {
            if (listeValeurs) { listeValeurs = listeValeurs + "; " }
            listeValeurs = listeValeurs + langue == 'en' ? element.Lang01 : element.Lang00;
        });

        return listeValeurs;
    },

    // Envoyer les tags analytics Googles et Eulerian
    envoyerTagsAnalytics(tagGoogle, tagEulerian, pathEtape, typeEtape, isPanier, typePanier) {

        // Log pour suivre l'envoi des tags
        console.log('Envoi tags : path ' + pathEtape + ', type ' + typeEtape + ', pannier : ' + typePanier)

        // Envoyer le tag google
        this.envoyerTagGoogleAnalytics(tagGoogle, pathEtape, typeEtape, isPanier)

        // Envoyer le tag Eulerian
        this.envoyerTagAnalyticsEulerian(tagEulerian, pathEtape, typeEtape, isPanier, typePanier)
    },

    // Envoyer les tags analytics Google
    envoyerTagGoogleAnalytics(tagGoogle, pathEtape, typeEtape, isPanier) {
        // Envoyer le tag google analytics:
        if (tagGoogle) {
            if (this.configurationClient.ParamFormulaire.EvtTagGoogle) {
                // Vérifier si nous somme dans l'étape de validation
                if (typeEtape) {
                    // Envoyer le tag google analytics pour l'étape de paiement
                    tagGoogle.push({
                        'event': this.configurationClient.ParamFormulaire.EvtTagGoogle,
                        'reference': Date.now(),
                        'mail': this.sasCandidature.Identification.Email,
                        'tel': this.sasCandidature.Identification.Telephone,
                        'path': pathEtape,
                        'formCategory': typeEtape,
                        'program': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.NomProgramme && this.sasCandidature.ChoixProgramme &&
                            this.sasCandidature.ChoixProgramme.NomProgramme.TypeProgramme ? this.sasCandidature.ChoixProgramme.NomProgramme.TypeProgramme.Lang00 : '',
                        'campus': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.Campus ? this.sasCandidature.ChoixProgramme.Campus.Lang00 : '',
                        'backToSchool': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.Rentree ? this.sasCandidature.ChoixProgramme.Rentree.Lang00 : '',
                        'admissionLevel': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.NiveauAdmission ? this.sasCandidature.ChoixProgramme.NiveauAdmission.Lang00 : '',
                        'amount': isPanier ? this.sasCandidature.Montant : '',
                        //'source' : source*, // Variable du champ source //  AGU : A voir !!
                    })
                }
                else {
                    // Envoyer le tag google analytics pour une étape avec un type ctegorie
                    tagGoogle.push({
                        'event': this.configurationClient.ParamFormulaire.EvtTagGoogle,
                        'reference': Date.now(),
                        'mail': this.sasCandidature.Identification.Email,
                        'tel': this.sasCandidature.Identification.Telephone,
                        'path': pathEtape,
                        'program': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.NomProgramme && this.sasCandidature.ChoixProgramme &&
                            this.sasCandidature.ChoixProgramme.NomProgramme.TypeProgramme ? this.sasCandidature.ChoixProgramme.NomProgramme.TypeProgramme.Lang00 : '',
                        'campus': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.Campus ? this.sasCandidature.ChoixProgramme.Campus.Lang00 : '',
                        'backToSchool': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.Rentree ? this.sasCandidature.ChoixProgramme.Rentree.Lang00 : '',
                        'admissionLevel': this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.NiveauAdmission ? this.sasCandidature.ChoixProgramme.NiveauAdmission.Lang00 : '',
                        'amount': isPanier ? this.sasCandidature.Montant : '',
                        //'source' : source*, // Variable du champ source //  AGU : A voir !!
                    })
                }
            }
        }
    },

    // Envoyer les tags analytics Eulerian
    envoyerTagAnalyticsEulerian(tagEulerian, pathEtape, typeEtape, isPanier, typePanier) {
        if (tagEulerian) {
            // Vérifier si nous somme dans l'étape de validation
            if (isPanier) {
                // Envoyer le tag Eulerian analytics pour l'étape de validation
                tagEulerian.push(
                    'uid', sha256(this.sasCandidature.Identification.Email),
                    'amount', this.sasCandidature.Montant,
                    'scart', '1',       //valeur 1 immuable//
                    'path', pathEtape,
                    'ref-panier', Date.now(),
                    'type-panier', typePanier
                )
            }
            else {
                if (typeEtape) {
                    // Récupérer le type du programme
                    let typeProg = this.sasCandidature.ChoixProgramme && this.sasCandidature.ChoixProgramme.NomProgramme && this.sasCandidature.ChoixProgramme &&
                        this.sasCandidature.ChoixProgramme.NomProgramme.TypeProgramme ? this.sasCandidature.ChoixProgramme.NomProgramme.TypeProgramme.Lang00 : ''

                    // Envoyer le tag Eulerian analytics pour une étape x
                    tagEulerian.push(
                        'uid', this.sasCandidature.Identification.Email ? sha256(this.sasCandidature.Identification.Email) : '',
                        'path', pathEtape,
                        'ref', Date.now(),
                        'estimate', '1',
                        'type', typeEtape + (typeProg ? ("-" + typeProg) : ''),
                        'choix-programme', typeProg
                    )
                }
                else {
                    // Envoyer le tag Eulerian analytics pour une étape x
                    tagEulerian.push(
                        'uid', this.sasCandidature.Identification.Email ? sha256(this.sasCandidature.Identification.Email) : '',
                        'path', pathEtape,
                    )
                }
            }
        }
    },

    // Ajouter le tag 
    addOneTrustTag(oneTrustId) {
        if (oneTrustId && oneTrustId != '') {
            let urlScript = 'https://cdn.cookielaw.org/consent/' + oneTrustId + '/otSDKStub.js'
            let oneTrustScript = document.createElement('script');
            oneTrustScript.setAttribute('src', urlScript);
            oneTrustScript.setAttribute('type', 'text/javascript');
            oneTrustScript.setAttribute('charset', 'UTF-8');
            oneTrustScript.setAttribute('data-domain-script', oneTrustId);
            document.head.appendChild(oneTrustScript);

            // Run 
            let oneTrustFct = document.createElement('script');
            oneTrustFct.setAttribute('type', 'text/javascript');
            oneTrustFct.innerHTML = ConstOneTrust.functionOptanonWrapper;
            //console.log("Constante : " + ConstOneTrust.functionOptanonWrapper)
            //console.log("après affectation dans inner text : " + oneTrustFct.innerText)
            //console.log("après affectation dans inner html : " + oneTrustFct.innerHTML)
            document.head.appendChild(oneTrustFct)
            console.log('oneTrust sent')
        }
    },

    // Vérification de la période d'inactivité. Renvoie faux si la période d'inactivité est trop longue.
    VerifPeriodActivite() {

        // Différence entre la date et heure de connexion et l'heure actuelle.
        var dif = moment.duration(moment(moment().format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss")
            .diff(moment(this.dateChargementPage, "DD/MM/YYYY HH:mm:ss")));

        // Différence en minute
        var minutes = (dif.hours() * 60) + dif.minutes()

        // Si le nombre d'heure est supérieurs à 2 heures alors on affiche la pop-up.
        if (parseInt(minutes) >= timeOutCandidature) {

            // Affichage de la pop-up.
            this.dialogTimeOut = true

            return false
        }
        else {
            // On réactualise l'heure d'inactivité.
            this.dateChargementPage = moment().format("DD/MM/YYYY HH:mm:ss")
        }
        return true
    }
}

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app');
